import React from 'react';
import { Label } from 'app/components/ui/label';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useFormContext } from 'react-hook-form';

export default function CourseDescription() {
  const { setValue, watch } = useFormContext();
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
    ],
  };

  return (
    <div className="bg-white  dark:bg-transparent rounded-lg p-4 mb-6">
      <Label htmlFor="course-description">Course Description</Label>
      <ReactQuill
        id="course-description"
        modules={modules}
        theme="snow"
        value={watch('description')}
        onChange={value => setValue('description', value)}
      />
    </div>
  );
}
